<template>
  <div class="break section-block row-box">
    <WrapperField
      v-for="(value, index) in data"
      :key="value + index + Math.random()"
      :data="createDataField({fieldName: index, fieldValue: value, fieldGroup: 'businessmen'})"
    ></WrapperField>
  </div>
</template>

<script>
import { createDataField } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';

export default {
  name: 'Businessmen',
  components: {
    WrapperField,
  },
  props: ['data', 'title'],
  data: () => ({
    createDataField,
  })
};
</script>
